import { PV_GENERAL_RECOMMENDATION_WORDING } from './report-extras.js';
export const ROOF_CAVITY_RECOMMENDATIONS = {
    'home-owner-not-home': PV_GENERAL_RECOMMENDATION_WORDING[4],
    'no-consent-to-access': PV_GENERAL_RECOMMENDATION_WORDING[5],
    'manhole-not-safely-accessible': 'The roof cavity was not inspected because the access opening could not be reached safely.',
    'no-roof-cavity': 'The roof cavity was not inspected because no roof cavity exists.',
};
function paragraphs(cover) {
    if (cover.roofCavityInspected !== false)
        return [];
    return [
        ...(cover.roofCavityNotInspectedReasons ?? []).map((reason) => ROOF_CAVITY_RECOMMENDATIONS[reason]),
        cover.roofCavityNotInspectedNote?.trim()
            ? `Roof cavity inspection: ${cover.roofCavityNotInspectedNote.trim()}`
            : '',
    ].filter(Boolean);
}
/** Replace only the exact generated paragraphs; preserve unrelated and edited prose. */
export function withRoofCavity(draft, patch) {
    const cover = { ...draft.cover, ...patch };
    if (cover.roofCavityInspected !== false) {
        cover.roofCavityNotInspectedReasons = [];
        cover.roofCavityNotInspectedNote = '';
    }
    let general = draft.generalRecommendations ?? draft.cover.inspectorRecommendation ?? '';
    for (const text of paragraphs(draft.cover)) {
        const escaped = text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        // Only remove a whole generated paragraph, not wording a reviewer has
        // extended or incorporated into a custom paragraph.
        general = general
            .replace(new RegExp(`(^|\\n\\s*\\n)${escaped}(?=\\n\\s*\\n|$)`, 'g'), '$1')
            .trim();
    }
    for (const text of paragraphs(cover))
        if (!general.includes(text))
            general = [general, text].filter(Boolean).join('\n\n');
    return { ...draft, cover, generalRecommendations: general.replace(/\n{3,}/g, '\n\n') };
}
//# sourceMappingURL=roof-cavity.js.map